import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./ResultPage.css";

const ResultPage = () => {
  const location = useLocation();
  const { questions = [], responses = {}, language: initialLanguage = "en" } = location.state || {};
  const [language, setLanguage] = useState(initialLanguage);
  const printRef = useRef(null);

  const getOption = (q, n) => language === "hi" ? q[`option${n}_hi`] : q[`option${n}_en`];
  const getQuestionText = (q) => language === "hi" ? q.question_text_hi : q.question_text_en;
  const getSolution = (q) => language === "hi" ? q.solution_hi : q.solution_en;

  const summary = questions.reduce((acc, question, index) => {
    const correct = parseInt(question.correct_option);
    const response = responses[index];
    if (response === undefined) acc.notAttempted++;
    else if (response + 1 === correct) acc.correct++;
    else acc.incorrect++;
    return acc;
  }, { correct: 0, incorrect: 0, notAttempted: 0 });

  const handlePrint = () => window.print();

  return (
    <div className="result-page">
      <div className="header">Download your PDF</div>

      <div className="content">
        <div className="controls">
         <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "10px 20px",
    gap: "12px", // This adds space between dropdown and button
    flexWrap: "wrap", // optional for responsiveness
  }}
>
  {/* Language Selector */}
  <select
    value={language}
    onChange={(e) => setLanguage(e.target.value)}
    style={{
      padding: "8px 12px",
      borderRadius: "8px",
      fontSize: "20px",
      border: "1px solid #ccc",
      cursor: "pointer",
      backgroundColor: "#f8f9fa",
    }}
  >
    <option value="en">English</option>
    <option value="hi">हिंदी</option>
  </select>

  {/* Download Button */}
  <button
    onClick={handlePrint}
    style={{
      background: "linear-gradient(to right, #4facfe, #00f2fe)",
      color: "#fff",
      padding: "10px 18px",
      borderRadius: "8px",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    }}
  >
    Download PDF
  </button>
</div>
          
        </div>

        <div className="summary">
          <p>Correct: {summary.correct}</p>
          <p>Incorrect: {summary.incorrect}</p>
          <p>Not Attempted: {summary.notAttempted}</p>
        </div>

        <div className="print-area" ref={printRef}>
          {questions.map((question, index) => {
            const correctOption = parseInt(question.correct_option);
            const userAnswerIndex = responses[index];
            const userAnswer = userAnswerIndex !== undefined ? userAnswerIndex + 1 : null;

            return (
              <div className="question" key={index}>
                <p>
                  Q{index + 1}. <span dangerouslySetInnerHTML={{ __html: getQuestionText(question) }} />
                </p>
                {[1, 2, 3, 4].map((n) => {
                  const isCorrect = correctOption === n;
                  const isSelected = userAnswer === n;

                  let className = "option";
                  if (isCorrect && isSelected) className += " correct";
                  else if (!isCorrect && isSelected) className += " incorrect";
                  else if (isCorrect) className += " correct";

                  return (
                    <div key={n} className={className}>
                      ({String.fromCharCode(64 + n)}){" "}
                      <span dangerouslySetInnerHTML={{ __html: getOption(question, n) }} />
                    </div>
                  );
                })}
                <div className="solution">
                  <strong>Explanation:</strong>{" "}
                  <span dangerouslySetInnerHTML={{ __html: getSolution(question) }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="footer">© 2025 BBM Classes </div>
    </div>
  );
};

export default ResultPage;